import React from 'react';
import Icon from 'components/lib/icons/icon';

/**
 * @visibleName Number
 */

export default function Number(props) {
  return (
    <Icon viewBox="0 0 14 14" {...props}>
      <path
        clipRule="evenodd"
        d="M7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0ZM8.39276 10.2727H7.25639L7.55114 8.46875H6.13068L5.83594 10.2727H4.69957L4.99432 8.46875H4L4.18821 7.33239H5.18253L5.4098 5.94034H4.41548L4.60724 4.80398H5.59801L5.89276 3H7.02912L6.73438 4.80398H8.15483L8.44957 3H9.58594L9.29119 4.80398H10.2891L10.0973 5.94034H9.10298L8.87571 7.33239H9.87003L9.68182 8.46875H8.6875L8.39276 10.2727ZM6.54616 5.94034L6.31889 7.33239H7.73935L7.96662 5.94034H6.54616Z"
        fillRule="evenodd"
      />
    </Icon>
  );
}
